/* ============
 * Objects Mixin
 * ============
 */
import {
  isEmpty,
  isNotEmpty,
  isArrayEmpty,
  clone,
  merge
} from '@/utils/object';

export default {
  /**
   * The methods that the mixin used for object functions.
   */
  methods: {
    isEmpty,
    isNotEmpty,
    isArrayEmpty,
    clone,
    merge,
    set(object, key, value) {
      this.$set(object, key, value);
    }
  }
};
